export const sanitizeUrlObject = (urlObj: URL | Record<string, any>) => {
  if (typeof urlObj.pathname === 'string' && urlObj.pathname.includes('#')) {
    const [cleanPath, hash] = urlObj.pathname.split('#');
    return { ...urlObj, pathname: cleanPath, hash };
  }
  return urlObj;
};

export const stripHash = (url: string | URL | Record<string, any>) => {
    if (typeof url === 'string') {
        return url.split('#')[0];
    }
    if (url && typeof url === 'object') {
        return sanitizeUrlObject(url);
    }
    return url;
};